import React from "react";
import "../pages/Proyect.css";
import htmlp from "../Assets/html_p.png";
import cssp from "../Assets/css_p.png";
import reactt from "../Assets/react_p.png";
import firee from "../Assets/firebase_p.png";
import green from "../Assets/green.png";
import BackButton from "../componets/BackButton";



export const GreenNotes = () => {
  const handleWebButtonClick = () => {
    window.location.href = "https://greenotes.netlify.app/"; // Reemplaza con la URL que quieras
  };

  const handleGitHubButtonClick = () => {
    window.location.href = "https://github.com/SusanaLab/CDMX011-lab-notes"; // Reemplaza con la URL de tu repositorio en GitHub
  };
  return (
    <div className="proyect-container">
      <BackButton/>
      <div className="proyect-header">
        <h1>GreenNotes </h1>
     
      <div className="proyect-description">
        <p>
         GreenNotes is a dynamic note-taking blog crafted to offer users a versatile application for creating, editing, and deleting notes. Developed using React and Firebase, it provides a seamless and secure experience, allowing users to manage their notes efficiently. With a focus on optimal organization, users can write, edit, and delete notes effortlessly.
<br/>
Key User Features:
<br/>
Note Management: Efficiently create, edit, and delete notes for optimal organization.
User Authentication: Securely log in with individual user accounts, enhancing data privacy.
Experience the convenience of a personalized and secure note-taking journey with GreenNotes, where React and Firebase technologies come together to elevate your productivity and organization.
        </p>
      </div>
      <div className="proyect-buttons">
          <button className="proyect-button" onClick={handleWebButtonClick}>Web</button>
      <button className="proyect-button" onClick={handleGitHubButtonClick}>GitHub</button>
      </div>
      <div className="proyect-tech">
        <p>Technologies</p>
        <img src={htmlp} alt="HTML" className="computer" />
        <img src={cssp} alt="CSS" className="computer" />
        <img src={reactt} alt="React" className="computer" />
        <img src={firee} alt="Firebase" className="computer" />
      </div> </div>
      <img
        src={green}
        alt="green"
        className="learning-image"
      />
    </div>
  );
};

